//
//
//
//
//
//
//
//
//
//
//

export default {
    name: 'Code',
    props: [
        'value'
    ]
}
